import api from './api';

const pedigreeService = {
  getAllPedigrees: async () => {
    const response = await api.get('/api/pedigrees');
    return response.data;
  },
  getPedigreeById: async (id) => {
    const response = await api.get(`/api/pedigrees/${id}`);
    return response.data;
  },
  createPedigree: async (data) => {
    const response = await api.post('/api/pedigrees', data);
    return response.data;
  },
  updatePedigree: async (id, data) => {
    const response = await api.put(`/api/pedigrees/${id}`, data);
    return response.data;
  },
  deletePedigree: async (id) => {
    const response = await api.delete(`/api/pedigrees/${id}`);
    return response.data;
  },
};

export default pedigreeService;